import { CheckSingleIcon, ExclamationMarkHexagonIcon } from '@grupoboticario/flora-react-icons';
import { Carousel } from 'ui/components/compounds/Carousel';
import { Picture, Text, ResponsiveFloraTypography } from 'ui/components/primitives';

import Styles from './Combo.components.styles';
import { Button } from './ComboButton';

import type { ComboChoicesProps } from './Combo.components.d';

const ComboChoices = ({ choices, isMobile, onChangeItem }: ComboChoicesProps) => (
  <>
    {choices.map((choice) => {
      const selectedAmount = choice.items.reduce((sum, { quantity }) => sum + quantity, 0);
      const isComplete = selectedAmount === choice.totalQuantity;
      const canAddItem = selectedAmount >= choice.totalQuantity;

      return (
        <Styles.Skus key={`choice-${choice.structureCode}`}>
          <ResponsiveFloraTypography as="h6" fontSize="subtitle" css={{ margin: 0 }}>
            Selecione a variação do produto {choice.description}
          </ResponsiveFloraTypography>
          <Styles.Tag data-completed={isComplete}>
            {isComplete ? <CheckSingleIcon size={12} /> : <ExclamationMarkHexagonIcon size={12} />}
            <Text variant="auxiliar-small">
              Você escolheu {selectedAmount} de {choice.totalQuantity}
            </Text>
          </Styles.Tag>

          <Styles.WrapperCarousel>
            <Carousel.Container
              container={true}
              desktop={!isMobile}
              dots
              itemsPerPage={{ desktop: 5, mobile: 2 }}
              navigationSize="sm"
            >
              {choice.items.map(({ available, code, image, name, quantity }) => (
                <Carousel.Slide key={`item-${choice.structureCode}-${code}`}>
                  <Styles.Sku data-testid={`item-${choice.structureCode}-${code}`} spacing="small">
                    <Picture
                      alt={name}
                      opacity={available ? '100' : '25'}
                      ratio="4x3"
                      sources={[
                        {
                          srcSet: `${image}`,
                        },
                      ]}
                      src={image}
                    />
                    <Styles.Text variant="body-medium-short">{name}</Styles.Text>
                    <Button
                      available={available}
                      code={code}
                      isComplete={isComplete}
                      isDisabled={canAddItem}
                      max={choice.totalQuantity}
                      onChangeItem={onChangeItem}
                      quantity={quantity}
                      structureCode={choice.structureCode}
                    />
                  </Styles.Sku>
                </Carousel.Slide>
              ))}
            </Carousel.Container>
          </Styles.WrapperCarousel>
        </Styles.Skus>
      );
    })}
  </>
);

export default ComboChoices;
